import { connect } from 'react-redux'

import DissociationCourse from '../../../components/ShipmentAction/DissociationCourse'
import { handleDissocierCourseClick } from '../../../redux/order/actions'
import {
  getErrorActionCourse,
  getIsLoadingActionOrder,
} from '../../../redux/order/selectors'

const mapStateToProps = (state) => ({
  isLoadingActionOrder: getIsLoadingActionOrder(state),
  errorActionCourse: getErrorActionCourse(state),
})
const mapDisptachToProps = (dispatch) => ({
  handleDissocierCourseClick: (codeCourse, payload) => {
    dispatch(handleDissocierCourseClick(codeCourse, payload))
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(DissociationCourse)
